import React from 'react';
import { observer } from 'mobx-react';
import { BaasicWarningModalTemplate } from 'themes/components';

function BaasicWarningModal(props) {
	return <BaasicWarningModalTemplate {...props} />;
}

export default observer(BaasicWarningModal);
